export const TRANSACTION_GROUP = {
    CONSUMER_FLOW_ANALYTICS: 'CONSUMER_FLOW_ANALYTICS',
};
export const SEVERITY = {
    fatal: "fatal",
    error: "error",
    warning: "warning",
    log: "log",
    info: "info",
    debug: "debug",
};
//# sourceMappingURL=constants.js.map